import { takeEvery, call, all, fork, put } from "@redux-saga/core/effects";
import {
  FETCH_TENANT_SUBSCRIPTION,
  SET_TENANT_SUBSCRIPTION,
  FETCH_CUSTOMER_SUBSCRIPTION,
  SET_CUSTOMER_SUBSCRIPTION,
  SET_CUSTOMER_SUBSCRIPTION_IS_LOADING,
  FETCH_STRIPE_CUSTOMER_DETAILS,
  SET_STRIPE_CUSTOMER_DETAILS,
  FETCH_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
  SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
  SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING,
  SET_CUSTOMER_SUBSCRIPTION_DONE_FETCHING,
} from "redux/constants/portal";
import { getSubscriptionAndProductInfo, getCustomerSubscription } from "api/PaymentGatewayApi";
import { getCustomerDetails } from "layouts/pages/billing/api/customersApi";
import { getRemainingActiveFlowsAndExecution } from "layouts/pages/billing/api/flowsAndExecution";

function* handleFetchTenantSubscription({ payload }) {
  try {
    const { tenant_id } = payload;
    const res = yield call(getSubscriptionAndProductInfo, tenant_id);
    yield put({ type: SET_TENANT_SUBSCRIPTION, payload: res });
  } catch (error) {
    console.error(error);
  }
}

function* handleFetchCustomerSubscription({ payload }) {
  try {
    const { customer_id } = payload;
    yield put({ type: SET_CUSTOMER_SUBSCRIPTION_IS_LOADING, payload: true });
    const res = yield call(getCustomerSubscription, customer_id);

    if (res?.resultObject?.data?.length) {
      yield put({ type: SET_CUSTOMER_SUBSCRIPTION, payload: res?.resultObject?.data[0] });
    }

    yield put({ type: SET_CUSTOMER_SUBSCRIPTION_DONE_FETCHING });
    yield put({ type: SET_CUSTOMER_SUBSCRIPTION_IS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: SET_CUSTOMER_SUBSCRIPTION_IS_LOADING, payload: false });
  }
}

function* handleFetchStripeCustomerDetails({ payload }) {
  try {
    const { customer_id } = payload;
    yield put({ type: SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING, payload: true });
    const res = yield call(getCustomerDetails, customer_id);
    if (res?.resultObject) {
      yield put({ type: SET_STRIPE_CUSTOMER_DETAILS, payload: res?.resultObject });
    }
  } catch (error) {
    console.error(error);
  }
  yield put({ type: SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING, payload: false });
}

function* handleFetchNumberOfRemainingActiveFlowsAndExecutions({ payload }) {
  try {
    const { tenant_id } = payload;
    const res = yield call(getRemainingActiveFlowsAndExecution, tenant_id);

    if (res?.resultObject) {
      yield put({
        type: SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
        payload: res?.resultObject,
      });
    }
  } catch (error) {
    console.error(error);
  }
}

function* watchFetchTenantSubscription() {
  yield takeEvery(FETCH_TENANT_SUBSCRIPTION, handleFetchTenantSubscription);
}

function* watchFetchCustomerSubscription() {
  yield takeEvery(FETCH_CUSTOMER_SUBSCRIPTION, handleFetchCustomerSubscription);
}

function* watchFetchStripeCustomerDetails() {
  yield takeEvery(FETCH_STRIPE_CUSTOMER_DETAILS, handleFetchStripeCustomerDetails);
}

function* watchFetchNumberOfRemainingActiveFlowsAndExecutions() {
  yield takeEvery(
    FETCH_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
    handleFetchNumberOfRemainingActiveFlowsAndExecutions
  );
}

export function* rootSubscriptionsSaga() {
  yield all([
    fork(watchFetchTenantSubscription),
    fork(watchFetchCustomerSubscription),
    fork(watchFetchStripeCustomerDetails),
    fork(watchFetchNumberOfRemainingActiveFlowsAndExecutions),
  ]);
}
